/**
 * The label to display when selected the filter
 */
export const labelCompetenzeTata = 'Competenze Tata';

export const labelFasceEta = 'Fasce Eta';
